// const ENDPOINT = "https://cvrs.slarenasitsolutions.com:8080";

const ENDPOINT = "https://dots-mern.onrender.com/";
// const ENDPOINT = "http://localhost:8080/";

export default ENDPOINT;
